import { registerParameters } from './tasks/registerParameters';

export function bootstrap() {
    return Promise.all([
        registerParameters(),
    ]);
}
